import React from "react";

import { useLocalization } from "@plex/culture-react";
import { DataTableDef } from "@plex/react-components";

import { commonMessages, defaultLocale } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";
import styles from "ui/screens/plex-dictionary/index.module.scss";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";

import { ITermTranslation } from "../TermTranslations.state";

export interface ITermTranslationsGridProps {
  translations?: ITermTranslation[];
}

export const TermTranslationsGrid: React.FC<ITermTranslationsGridProps> = ({ translations }) => {
  const { t } = useLocalization();

  const localizedValues = useLocalizedValues(() => ({
    refineSearch: commonMessages.info("refineSearch"),
    startSearch: commonMessages.info("startSearch"),
    locale: glossaryMessages.property("locale"),
    localeName: { value: defaultLocale.name },
    industry: glossaryMessages.property("industry"),
    term: glossaryMessages.property("term"),
    description: glossaryMessages.property("description"),
    source: glossaryMessages.property("source"),
    status: glossaryMessages.property("status")
  }));

  return (
    <DataTableDef<ITermTranslation>
      data={translations ? translations : []}
      keySelector={row => row.translationId}
      emptyText={translations ? localizedValues.refineSearch : localizedValues.startSearch}
    >
      <DataTableDef.Column<ITermTranslation> id="locale" title={localizedValues.locale} sortable>
        {row => (row.localeName === defaultLocale.name ? localizedValues.localeName : row.localeName)}
      </DataTableDef.Column>
      <DataTableDef.Column<ITermTranslation> id="industry" title={localizedValues.industry} sortable>
        {row => row.industryDescription}
      </DataTableDef.Column>
      <DataTableDef.Column<ITermTranslation> id="term" title={localizedValues.term} sortable valueSelector={row => row.translation}>
        {row => <p className={styles.wrapText}>{row.translation}</p>}
      </DataTableDef.Column>
      <DataTableDef.Column<ITermTranslation> id="description" title={localizedValues.description} sortable valueSelector={row => row.definition}>
        {row => <p className={styles.wrapText}>{row.definition}</p>}
      </DataTableDef.Column>
      <DataTableDef.Column<ITermTranslation> id="source" title={localizedValues.source} sortable>
        {row => (row.source ? t(row.source) : "")}
      </DataTableDef.Column>
      <DataTableDef.Column<ITermTranslation> id="status" title={localizedValues.status} sortable>
        {row => (row.status ? t(row.status) : "")}
      </DataTableDef.Column>
    </DataTableDef>
  );
};
